/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestRequestBody
 */
export interface RequestRequestBody {
    /**
     * UUID of the related package
     * @type {string}
     * @memberof RequestRequestBody
     */
    packageUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRequestBody
     */
    type: RequestRequestBodyTypeEnum;
}


/**
 * @export
 */
export const RequestRequestBodyTypeEnum = {
    Psu: 'PSU',
    Pd: 'PD',
    Scu: 'SCU'
} as const;
export type RequestRequestBodyTypeEnum = typeof RequestRequestBodyTypeEnum[keyof typeof RequestRequestBodyTypeEnum];


/**
 * Check if a given object implements the RequestRequestBody interface.
 */
export function instanceOfRequestRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function RequestRequestBodyFromJSON(json: any): RequestRequestBody {
    return RequestRequestBodyFromJSONTyped(json, false);
}

export function RequestRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'packageUuid': !exists(json, 'package_uuid') ? undefined : json['package_uuid'],
        'type': json['type'],
    };
}

export function RequestRequestBodyToJSON(value?: RequestRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'package_uuid': value.packageUuid,
        'type': value.type,
    };
}

